import {AdminSignInValueObject} from "../../model/vo/admin/AdminSignInValueObject";
import {DefaultIO, defaultIO} from "../DefaultIO";

export const AdminSignInIO: Readonly<Omit<DefaultIO<AdminSignInValueObject>, 'put' | 'delete'>> = Object.freeze(
    defaultIO(
        '/api/v3/admins/signIns',
        AdminSignInValueObject.construct
    )
)